class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=3&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.nextElementSibling.style.display = 'none';
    this.predictiveSearchResults.style.display = 'grid';
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.nextElementSibling.style.display = 'block';
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              // window.location.href = "/cart";
              $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
                window.history.pushState({}, null, '/cart');  
              });
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search','open-wishlist');
    document.querySelector('.combine-with-colors').classList.remove('active');
  }
}
function addItem(data_line,qty){
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity="+qty+"&id=" + data_line,
    dataType: "json",
    success: function (e){
      if(document.location.href.indexOf('/cart') > -1) {
        // window.location.href = "/cart";
        $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
          window.history.pushState({}, null, '/cart');  
        });
      }else{
        load_cart();
      }
    },
    error: function (e, t){}
  });
}
$(document).on('click','.ci_plus a', function (e) {
  e.preventDefault();
  var $qty = $(this).closest('.ci_qtybox').find(".cart_qty");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal)) {
    $qty.val(currentVal+1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.ci_plus').data('line');
    addItem(data_line,input_qty);
  }
});
$(document).on('click','.ci_minus a', function (e) {
  e.preventDefault();
  var $qty = $(this).closest('.ci_qtybox').find(".cart_qty");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.ci_minus').data('line');
    addItem(data_line,input_qty);
  }
});
$(document).on('click','.upsell-cart',function(e){
  e.preventDefault();
  var upsell_id = $(this).data('id');
  var _this = $(this).closest('li');
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: upsell_id, quantity: 1 },
    dataType: "json",
    success: function (t) {
      if(window.location.href.includes('cart')){
        // window.location.href = "/cart";
        $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
          window.history.pushState({}, null, '/cart');  
        });
      }else{
        load_cart();
      }
      $(".cart-sidebar").animate({ scrollTop: 0 }, "slow");
    },
    error: function (e, t) {
      _this.find('.upsell-error').text(e.responseJSON.description);
      setTimeout(function(){
        _this.find('.upsell-error').text('');
      }, 2000);
    },
  });
});
$(document).on('click','.gift-cart',function(e){
  e.preventDefault();
  let gift_id = $(this).attr('data-id');
  let properties = $(this).parents('.item-row').attr('data-id');
  let remove_gift = false;
  // let get_property = $('.item-row').attr('data-properties');
  let data_line;
  $('.item-row[data-properties]').each(function(){
    let get_property = $(this).attr('data-properties');
    if(get_property == properties){
      remove_gift = true
      data_line = $(this).find('.item-remove').attr('data-line')
    }
  })
  // if(get_property == properties){
  //   remove_gift = true
  //   data_line = $('.item-row[data-properties]').find('.item-remove').attr('data-line')
  // }
  if(remove_gift){
    const data = {'line': data_line ,'quantity': 0 };
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then((data) => {
      if(document.location.href.indexOf('/cart') > -1) {
        // window.location.href = "/cart";
        $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
          window.history.pushState({}, null, '/cart');  
        });
      }else{
        load_cart();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }else{
    // data_line = $('.item-row[data-properties]').find('.item-remove').attr('data-line')
    // console.log('elseeee',data_line);
    // if(data_line != undefined){
    //   const rdata = {'line': data_line ,'quantity': 0 };
    //   fetch('/cart/change.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(rdata),
    //   })
    //   .then((response) => response.json())
    //   .then((rdata) => {})
    //   .catch((error) => {console.error('Error:', error);});
    // }
    // setTimeout(function(){
      const data = {
        quantity: 1, 
        id: gift_id,
        properties:{
          'Product ID': properties,
          'To wrap': document.querySelector('.item-row').getAttribute('data-title')
        }
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
        if(document.location.href.indexOf('/cart') > -1) {
          // window.location.href = "/cart";
          $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
            window.history.pushState({}, null, '/cart');  
          });
        }else{
          load_cart();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    // }, 500);
  }
});
/** Shopify CDN: Minification failed Line 32:6 Transforming const to the configured target environment ("es5") is not supported yet **/
var counttime = 0;
function cartNotification(cartId) {
  $.ajax({
    type: "GET",
    url: "?section_id=cart-notification",
    dataType: "HTML",
    success: function (data) {
      var temp_data = $(".cart_popup").html(data);
      var lastItem = $(".ch_items").find(".cn_" + cartId).html();
      $(".ch_items").html(lastItem);
      $("body").removeClass('open-wishlist').addClass("fillcart");
      counttime = 0;
      const myInterval = setInterval(timer, 1000);
      function timer() {
        counttime++;
        if (counttime > 4) {
          $(".cart_popup").html("");
          $("body").removeClass('.fillcart');
          myStop();
        }
      }
      function myStop() {
        clearInterval(myInterval);
      }      
    },
    error: function (error) {
      $(".cnerror").html(error.responseJSON.description);
    },
  });
}
$(document).on("click", ".cn_close", function (e) {
  e.preventDefault();
  $(".cart_popup").html("");
});
$(document).on('click','.cn_btn a',function(e){
  e.preventDefault();
  $('body').addClass('open-drawer');
  $(".cart_popup").html("");
  $('.snippet-addto-cart').removeClass('successcart');
});